/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsRetrieveParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsRetrieveParams = zod.input<
    typeof ApiAccountsRetrieveParams
>;
export type ApiAccountsRetrieveParamsOutput = zod.output<
    typeof ApiAccountsRetrieveParams
>;
